import React, { useEffect, useState } from 'react';
import { Col, Form, FormInstance, Row, Spin, Select, ColProps } from 'antd';
import FormInput from 'components/FormInput';
import { getDistinctCityByZipCode, getParAddress, getZipcodesByCity } from 'services/parametersService';
import Icon, { CloseCircleTwoTone } from '@ant-design/icons';
import { CSSProperties } from 'styled-components';
import { useQuery } from 'react-query';
import _ from 'lodash';

export type AddressProps = {
  labelAlign?: 'right' | 'left';
  form: FormInstance;
  paysField?: string;
  regionGlobalField?: string;
  regionField?: string;
  villeField?: string;
  codePostalField?: string;
  comcoderegionGlobalField?: string;
  comcoderegionField?: string;
  comcodevilleField?: string;
  comcodecodePostalField?: string;
  comcodepaysField?: string;
  colU?: number;
  spanZip?: number;
  spanRegion?: number;
  spanCity?: number;
  spanGlobalRegion?: number;
  spanCountry?: number;
  disabled?: boolean;
  hideRegionGlobal?: boolean;
  hideRegion?: boolean;
  villeFirst?: any;
  regionFirst?: any;
  addValue?: boolean;
  countryRequired?: boolean;
  zipcodeRequired?: boolean;
  cityRequired?: boolean;
  style?: CSSProperties;
  styles?: CSSProperties;
  Colw?: ColProps;
  className?: string;
};

const AddressSFS: React.FC<AddressProps> = ({
  form,
  paysField = 'pays',
  regionGlobalField = 'regionGlobal',
  regionField = 'region',
  villeField = 'ville',
  codePostalField = 'codePostal',
  disabled = false,
  spanZip,
  spanRegion,
  spanCity,
  spanGlobalRegion,
  spanCountry,
  className,
  cityRequired,
  zipcodeRequired,
  countryRequired,
}) => {
  const INIT_SEARCH_PARMAS = {
    zipcode: '',
    cityOrcityLabel: '',
  };

  const [searchParams, setSearchParams] = useState(INIT_SEARCH_PARMAS);
  const [Cities, setCities] = useState<any[]>([]);
  const [zipcodes, setZipcodes] = useState<any[]>([]);
  const [countries, setCountries] = useState<any[]>([]);
  const [cityOrcityLabel, setcityOrcityLabel] = useState<String>("");
  const [zipcode, setZipcode] = useState<String>("");


  const { data: dataParAddressZipCode, isLoading: isLoadingParAddressZipCode } = useQuery(
    ['getParAddressZipCode', cityOrcityLabel],
    () => getParAddress({ cityOrcityLabel: cityOrcityLabel, zipcode: '' }).then((res) => res.list || []), { refetchOnWindowFocus: false, keepPreviousData: true }
  );


  const { data: dataParAddressCity, isLoading } = useQuery(
    ['getParAddressCity', zipcode],
    () => getParAddress({ zipcode: zipcode, cityOrcityLabel: '' }).then((res) => res.list || []), { refetchOnWindowFocus: false, keepPreviousData: true }
  );



  return (
    <Col span={24}>

      <Row gutter={17} justify="space-between">
        <Form.Item shouldUpdate noStyle>
          {({ getFieldValue }) => (
            <FormInput
              md={spanZip ?? 8}
              col
              xs={4}
              labelAlign="right"
              name={codePostalField}
              rules={[
                {
                  required: zipcodeRequired,
                  message: 'please enter zipcode',
                },
              ]}
            >
              <Select
                className={className ?? ''}
                showSearch
                // value={getFieldValue(codePostalField)}
                disabled={disabled}
                onChange={((e) => {
                  if (cityOrcityLabel != null && cityOrcityLabel?.length == 0) {
                    setZipcode(e)
                  } else {
                    setZipcode('')
                  }
                })}
                loading={isLoadingParAddressZipCode}
                onClear={() => {
                  form.setFieldValue(villeField, '')
                  setcityOrcityLabel('');
                  setZipcode('');
                }}
                allowClear
              >
                {_.uniqBy(dataParAddressZipCode, 'zipcode')?.map((item: any) => (
                  <Select.Option key={item.zipcode} value={item.zipcode}>
                    {item.zipcode}
                  </Select.Option>
                ))}
              </Select>
            </FormInput>
          )}
        </Form.Item>

        <Form.Item shouldUpdate noStyle>
          {({ getFieldValue }) => (
            <FormInput
              md={spanCity ?? 11}
              col
              xs={4}
              labelAlign="right"
              name={villeField}
              rules={[
                {
                  required: cityRequired,

                  message: 'please enter city',
                },
              ]}
            >
              <Select
                className={className ?? ''}
                showSearch
                value={getFieldValue(villeField)} // Bind value to the form field
                allowClear
                disabled={disabled}
                filterOption={false} // Disable default filtering behavior
                onChange={(e) => {
                  if (zipcode != null && searchParams.zipcode?.length == 0) {
                    setcityOrcityLabel(e)
                  } else {
                    setcityOrcityLabel('')
                  }
                }}
                loading={isLoading}
                onClear={() => {
                  form.setFieldValue(villeField, '')
                }}
              >
                {_.uniqBy(dataParAddressCity, 'city')?.map((item: any) => (
                  <Select.Option key={item.city} value={item.city}>
                    {item.citylabel}
                  </Select.Option>
                ))}
              </Select>
            </FormInput>
          )}
        </Form.Item>
        <Form.Item shouldUpdate noStyle>
          {({ getFieldValue }) => (
            <FormInput
              col
              md={spanCountry ?? 8}
              xs={4}
              labelAlign="right"
              name={paysField}
              rules={[
                {
                  required: countryRequired,
                  message: 'please enter country',
                },
              ]}
            >
              <Select
                className={className ?? ''}
                showSearch
                allowClear
                disabled={disabled}
              >
                {_.uniqBy(dataParAddressCity, 'country')?.map((item: any, index: number) => (
                  <Select.Option key={index} value={item.country}>
                    {item.countrylabel}
                  </Select.Option>
                ))}
              </Select>
            </FormInput>
          )}
        </Form.Item>
      </Row>
    </Col>
  );
};
export default AddressSFS;
